import script from "./Catalog.vue?vue&type=script&setup=true&lang=js"
export * from "./Catalog.vue?vue&type=script&setup=true&lang=js"

import "./Catalog.vue?vue&type=style&index=0&id=22a9effd&scoped=true&lang=css"

import exportComponent from "E:\\TestProject Temurako\\e-commerce-app-master\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-22a9effd"]])

export default __exports__